import React from 'react';
import { Button } from 'antd';
import '../styles/Footer.css';

interface FooterProps {
  language: 'en' | 'zh';
  setLanguage: (lang: 'en' | 'zh') => void;
}

const Footer: React.FC<FooterProps> = ({ language, setLanguage }) => {
  return (
    <footer className="site-footer">
      <div className="footer-content">
        <div className="social-links">
          <h3 className="social-title">
            {language === 'en' ? "Follow Us" : "关注我们"}
          </h3>
          <div className="social-icons">
            <a
              href="https://x.com/web3aicreator?s=21"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
              title={language === 'en' ? "Official X Account" : "官方 X 账号"}
            >
              <span className="social-icon">𝕏</span>
              <span className="social-text">
                {language === 'en' ? "Official Account" : "官方账号"}
              </span>
            </a>
            <a
              href="https://x.com/NcgCommuntiyCTO"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
              title={language === 'en' ? "Community X Account" : "社区 X 账号"}
            >
              <span className="social-icon">𝕏</span>
              <span className="social-text">
                {language === 'en' ? "Community Account" : "社区账号"}
              </span>
            </a>
          </div>
        </div>
        
        <div className="footer-language-toggle">
          <Button
            type={language === 'en' ? "primary" : "default"}
            onClick={() => setLanguage('en')}
            className="footer-lang-button"
          >
            English
          </Button>
          <Button
            type={language === 'zh' ? "primary" : "default"}
            onClick={() => setLanguage('zh')}
            className="footer-lang-button"
          >
            中文
          </Button>
        </div>
        
        <p className="copyright-text">
          © {new Date().getFullYear()} NovaCrafter Lab
        </p>
      </div>
    </footer>
  );
};

export default Footer; 